import React, { useState, useEffect } from "react";
import { Navigate, Link } from "react-router-dom";
import { store } from "../../App";
import { makeCallOnOpen } from "../../Redux/TrackerActions";
import { connect } from 'react-redux';
import { setToast } from "../../Redux/OverlayActions";
import { useTranslation } from "../../hooks/useTranslation";
import "../SilentAddress/SilentAddressView.css";

function AmbiguousAddressView({ addressOptions }) {
    const { t } = useTranslation();
    const [selectedOption, setSelectedOption] = useState(null);
    const [redirectToTracker, setRedirectToTracker] = useState(false);

    useEffect(() => {
        if (!addressOptions) {
            store.dispatch(setToast({
                message: t('addressPage.errors.somethingWrong', 'Er liep iets fout! Probeer het opnieuw.'),
                theme: "error",
            }));
            setRedirectToTracker(true);
        }
    }, [addressOptions, t]);

    const handleSelect = (option) => {
        setSelectedOption(option);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!selectedOption) return;

        window.localStorage.setItem('placeid', selectedOption.placeid);
        window.localStorage.setItem('latitude', selectedOption.latitude);
        window.localStorage.setItem('longitude', selectedOption.longitude);
        window.localStorage.setItem('adres', selectedOption.adres);

        store.dispatch(makeCallOnOpen());
        setRedirectToTracker(true);
    };

    if (redirectToTracker) {
        return <Navigate to="/" />;
    }

    return (
        <div className="address-page call-theme">
            <div className="address-header">
                <div className="address-header-icon call-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                </div>
                <h1>{t('addressPage.ambiguous.title', 'Adres bevestigen')}</h1>
                <p>{t('addressPage.ambiguous.subtitle', 'We vonden meerdere mogelijke adressen. Selecteer het juiste adres.')}</p>
            </div>

            <form className="address-form" onSubmit={handleSubmit}>
                <div className="form-section">
                    <div className="address-options">
                        {addressOptions && addressOptions.map((option, index) => (
                            <label
                                key={option.placeid || index}
                                className={`address-option ${selectedOption?.placeid === option.placeid ? 'selected' : ''}`}
                            >
                                <input
                                    type="radio"
                                    name="address"
                                    value={option.placeid}
                                    checked={selectedOption?.placeid === option.placeid}
                                    onChange={() => handleSelect(option)}
                                />
                                <div className="option-content">
                                    <div className="option-icon">
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                            <circle cx="12" cy="10" r="3"></circle>
                                        </svg>
                                    </div>
                                    <span className="option-text">{option.adres}</span>
                                    {selectedOption?.placeid === option.placeid && (
                                        <div className="option-check call-check">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                        </div>
                                    )}
                                </div>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="form-actions">
                    <button
                        type="submit"
                        className="btn-submit call-btn"
                        disabled={!selectedOption}
                        style={{ opacity: selectedOption ? 1 : 0.5 }}
                    >
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                        {t('addressPage.ambiguous.confirmButton', 'Bevestigen')}
                    </button>
                    <Link to="/address" className="btn-cancel">
                        {t('addressPage.cancelButton', 'Annuleren')}
                    </Link>
                </div>
            </form>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        addressOptions: state.tracker.addressOptions || null,
    };
}

export default connect(mapStateToProps)(AmbiguousAddressView);
